export const SELECTED_SONG = 'selected_song/SELECTED_SONG';
export const SELECTED_ALBUM = 'selected_album/SELECTED_ALBUM';
export const IS_PLAYING = 'is_playing/IS_PLAYING';
export const CHANGE_PREVIOUS_SONG = 'change_previous_song/CHANGE_PREVIOUS_SONG';
export const CHANGE_NEXT_SONG = 'change_next_song/CHANGE_NEXT_SONG';
